import { Heading, Icon, Stack } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

interface CancelledAppointmentDisplayProps {
  message?: string;
  className?: string;
}

export const CancelledAppointmentDisplay: React.FC<
  CancelledAppointmentDisplayProps
> = ({ message, className }) => {
  const { t } = useTranslation();
  const displayMessage = message ?? t('appointmentTools.page.canceledInEhr');
  return (
    <Stack
      className={`gap-12 p-2 ${className || ''}`}
      align="center"
      gap={2}
      justify="center"
    >
      <Icon
        name="CalendarX2Icon"
        size="xl"
        className="size-24 text-border-tertiary"
      />
      <Heading size="xl" level={3} className="text-center text-balance">
        {displayMessage}
      </Heading>
    </Stack>
  );
};
